module.exports = __webpack_public_path__ + "img/airflow.5c894604.svg";